import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import PropTypes from 'prop-types'
import TargetDatePast from '../../../../static/images/icons/icon_target_date-past.svg'
import TargetDate8PlusDays from '../../../../static/images/icons/icon_target_date-8-plus-days.svg'
import TargetDateWithin7Days from '../../../../static/images/icons/icon_target_date-within_7_days.svg'
import colors from '../../../../configuration/colors'

const Icon = styled.img`
  width: 15px;
  height: 15px;
  filter: ${props => props.theme.svgFilter};
`

const Date = styled.p`
  font-size: 13px;
  margin: 0 0 0 5px;
  color: ${props => props.theme.p1};
`
Date.displayName = 'Date'

const TargetDateBlock = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
`
const TargetDateIcon = ({
  targetDate,
  shouldShowDate,
  startAlign,
  shouldBeLeftAlign,
  shouldHideIcon
}) => {
  if (targetDate) {
    const now = moment()
    const target = moment(targetDate.target_on, 'YYYY-MM-DD')
    const diff = target.diff(now, 'd')

    if (diff >= 6) {
      return !shouldHideIcon ? (
        <TargetDateBlock
          style={{
            justifyContent: startAlign ? 'flex-start' : 'flex-end',
            marginTop: shouldBeLeftAlign ? '10px' : '0'
          }}
        >
          <Icon src={TargetDate8PlusDays} />
          {shouldShowDate === true && (
            <Date style={{ color: colors.dove, fontWeight: 300 }}>
              {moment(targetDate.target_on).format('D MMM')}
            </Date>
          )}
        </TargetDateBlock>
      ) : (
        <div style={{ width: '15px', height: '15px' }} />
      )
    } else if (diff >= 0) {
      return (
        <TargetDateBlock
          style={{
            justifyContent: startAlign ? 'flex-start' : 'flex-end',
            marginTop: shouldBeLeftAlign ? '10px' : '0'
          }}
        >
          <Icon src={TargetDateWithin7Days} />
          {shouldShowDate && (
            <Date style={{ color: colors.silver, fontWeight: 500 }}>
              {moment(targetDate.target_on).format('D MMM')}
            </Date>
          )}
        </TargetDateBlock>
      )
    } else {
      return (
        <TargetDateBlock
          style={{
            justifyContent: startAlign ? 'flex-start' : 'flex-end',
            marginTop: shouldBeLeftAlign ? '10px' : '0'
          }}
        >
          <Icon src={TargetDatePast} />
          {shouldShowDate && (
            <Date style={{ color: colors.victoria, fontWeight: 500 }}>
              {moment(targetDate.target_on).format('D MMM')}
            </Date>
          )}
        </TargetDateBlock>
      )
    }
  } else {
    return null
  }
}

TargetDateIcon.propTypes = {
  targetDate: PropTypes.object,
  shouldShowDate: PropTypes.bool
}

export default TargetDateIcon
